<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('activities.listing.massActions.ActivitiesMassMarkAsDone.title')"
        :primaryAction="{
            label: $t.__('common.actions.confirm'),
            action: () => handleConfirm(),
            loading: isSubmitting,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                action: () => {
                    $emit('close');
                },
            },
        ]"
        @closed="$emit('close')"
    >
        <template #default>
            <CompassAlert
                :description="
                    $t.__('activities.listing.massActions.ActivitiesMassMarkAsDone.infoAlert')
                "
                :showClose="false"
            />
            <span class="typographies-paragraph-medium-regular">{{ textContent }}</span>
        </template>
    </CompassDialog>
</template>
<script>
import { massMarkAsDone } from 'api/activities/activitiesMassActionsService.js';
export default {
    props: {
        selectedActivities: {
            type: Array,
            default: () => [],
        },
        onError: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showModal: true,
            isSubmitting: false,
        };
    },
    computed: {
        textContent() {
            return this.$l10n.n__(
                'Vous vous apprêtez à marquer une activité comme terminée.',
                'Vous vous apprêtez à marquer %d activités comme terminées.',
                this.selectedActivities.length,
                this.selectedActivities.length,
            );
        },
    },
    methods: {
        async handleConfirm() {
            try {
                this.isSubmitting = true;
                await massMarkAsDone(this.selectedActivities);
                await new Promise(() =>
                    setTimeout(() => {
                        this.$emit('close');
                        this.onSuccess();
                    }, 200),
                );
            } catch (error) {
                this.onError(error);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
